// export const getInfo = (
//     data: IRefrenceKeyRequest
// ): Promise<IGetInfoResponse> => {
//     return Axios.post<ApiResultModel<IGetInfoResponse>>(
//         APIBASE_URL + RESIDENTIAL + '/GetInfo',
//         data
//     ).then((result) => {
//         return result.data.data;
//     });
// };

import Axios from 'axios';
import { ApiResultModel, IDocument } from "../models/common.model";
import { CheckCompletionResponse, GetGuaranteedLoansResponse, IAddFileRequeste, IAddGuarantorReqsponse, IAddGuarantorRequest, IDeleteFileRequeste, IDeleteGuarantorRequest, IGetGuarantorAdditionalInfoResponse, IGetGuarantorChequeRequest, IGetGuarantorChequeResponse, IGetGuarantorsResponse, IRegisterGuarantorChequeRequest, IUpdateGuarantorAdditionalInfoRequest } from "../models/guarantor.model";
import { APIBASE_URL, GUARANTOR } from "../config/cacheKey";
import { IRefrenceKeyRequest } from '../models/registration.model';



export const addGuarantor = (
    data: IAddGuarantorRequest
): Promise<IAddGuarantorReqsponse> => {
    return Axios.post<ApiResultModel<IAddGuarantorReqsponse>>(
        APIBASE_URL + GUARANTOR + '/AddGuarantor',
        data
    ).then((result) => {
        return result.data.data;
    });
};
export const deleteGuarantor = (
    data: IDeleteGuarantorRequest
): Promise<boolean> => {
    return Axios.post<ApiResultModel<boolean>>(
        APIBASE_URL + GUARANTOR + '/DeleteGuarantor',
        data
    ).then((result) => {
        return result.data.data;
    });
};
export const getGuarantors = (
    data: IRefrenceKeyRequest
): Promise<IGetGuarantorsResponse[]> => {
    return Axios.post<ApiResultModel<IGetGuarantorsResponse[]>>(
        APIBASE_URL + GUARANTOR + '/GetGuarantors',
        data
    ).then((result) => {
        return result.data.data;
    });
};
export const getGuarantorCheque = (
    data: IGetGuarantorChequeRequest
): Promise<IGetGuarantorChequeResponse> => {
    return Axios.post<ApiResultModel<IGetGuarantorChequeResponse>>(
        APIBASE_URL + GUARANTOR + '/GetGuarantorCheque',
        data
    ).then((result) => {
        return result.data.data;
    });
};
export const registerGuarantorCheque =
    async (request: IRegisterGuarantorChequeRequest)
        : Promise<ApiResultModel<IGetGuarantorChequeResponse>> => {
        const formData = new FormData();
        formData.append('guarantorKey', request.guarantorKey);
        formData.append('sayadNumber', request.sayadNumber);
        formData.append('frontImage', request.frontImage!);
        formData.append('rearImage', request.rearImage!);
        formData.append('referenceKey', request.referenceKey!);
        return await Axios.post<ApiResultModel<IGetGuarantorChequeResponse>>(
            APIBASE_URL + GUARANTOR + '/RegisterGuarantorCheque',
            formData,
            {
                headers: {
                    'Content-Type': 'multipart/form-data; charset=utf-8',
                    // Accept: 'multipart/form-data',
                },
            }
        ).then((result) => {
            return result.data;
        });
    };
export const updateGuarantorAdditionalInfo =
    async (request: IUpdateGuarantorAdditionalInfoRequest)
        : Promise<boolean> => {
        const formData = new FormData();
        formData.append('key', request.key);
        formData.append('incomeRangeOptionId', request.incomeRangeOptionId.toString());
        formData.append('referenceKey', request.referenceKey!);

        return await Axios.post<ApiResultModel<boolean>>(
            APIBASE_URL + GUARANTOR + '/UpdateGuarantorAdditionalInfo',
            formData,
            {
                headers: {
                    'Content-Type': 'multipart/form-data; charset=utf-8',
                    Accept: 'multipart/form-data',
                },
            }
        ).then((result) => {
            return result.data.data;
        });
    };

export const getGuarantorAdditionalInfo = (
    data: IDeleteGuarantorRequest
): Promise<IGetGuarantorAdditionalInfoResponse> => {
    return Axios.post<ApiResultModel<IGetGuarantorAdditionalInfoResponse>>(
        APIBASE_URL + GUARANTOR + '/GetGuarantorAdditionalInfo',
        data
    ).then((result) => {
        return result.data.data;
    });
};

export const addFile =
    async (request: IAddFileRequeste)
        : Promise<ApiResultModel<IDocument>> => {
        const formData = new FormData();
        formData.append('guarantorKey', request.guarantorKey);
        formData.append('documentType', request.documentType);
        formData.append('file', request.file!, request.file?.name);
        formData.append('referenceKey', request.referenceKey);
        return await Axios.post<ApiResultModel<IDocument>>(
            APIBASE_URL + GUARANTOR + '/AddFile',
            formData,
            {
                headers: {
                    'Content-Type': 'multipart/form-data; charset=utf-8',
                    Accept: 'multipart/form-data',
                },
            }
        ).then((result) => {
            return result.data;
        });
    };

export const deleteFile = (
    data: IDeleteFileRequeste
): Promise<boolean> => {
    return Axios.post<ApiResultModel<boolean>>(
        APIBASE_URL + GUARANTOR + '/DeleteFile',
        data
    ).then((result) => {
        return result.data.data;
    });
};

export const GetGuaranteedLoans = async (): Promise<GetGuaranteedLoansResponse[]> => {
    return await Axios.post<ApiResultModel<GetGuaranteedLoansResponse[]>>(
        APIBASE_URL + GUARANTOR + '/GetGuaranteedLoans'
    ).then((result) => {
        return result.data.data;
    });
};
export const CheckCompletion = async (data: IGetGuarantorChequeRequest): Promise<CheckCompletionResponse> => {
    return await Axios.post<ApiResultModel<CheckCompletionResponse>>(
        APIBASE_URL + GUARANTOR + '/CheckCompletion',
        data
    ).then((result) => {
        return result.data.data;
    });
};
